import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { map, Observable, startWith } from 'rxjs';
import { MyUtils } from 'src/app/services/my-utils.service';
import { InputFormModel } from '../models/input-form';

@Component({
  selector: 'app-generate-autocomplete-multiselect-input',
  templateUrl: './generate-autocomplete-multiselect-input.component.html',
  styleUrls: ['./generate-autocomplete-multiselect-input.component.scss']
})
export class GenerateAutocompleteMultiSelectInputComponent implements OnInit {
  @Input() item!: InputFormModel | undefined;
  @Input() form!: FormGroup;
  @Input() appearanceForm!: string | undefined;
  groups: any;
  formName: any;
  groupsBK: any;
  appearance: MatFormFieldAppearance = 'fill' as MatFormFieldAppearance;
  elements: any[] = [];
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  elementCtrl = new FormControl();

  @ViewChild('inputChips') inputChips!: ElementRef<any>;
  @ViewChild('auto') matAutocomplete!: MatAutocomplete;
  filteredElements: Observable<void | string[]> | undefined;

  constructor(public utils: MyUtils) {


  }

  ngOnInit() {

    this.appearance = this.appearanceForm as MatFormFieldAppearance;
    this.groups = this.item?.objectSelect;
    this.groupsBK = this.groups;
    this.formName = this.item?.formControlName;

    this.elements = this.form.controls[this.formName].value ? this.form.controls[this.formName].value : []

    this.elementCtrl.valueChanges.subscribe((value: any) => this._filter(value))
    this.filteredElements = this.elementCtrl.valueChanges.pipe(
      startWith(null),
      map((element: string | null) => element ? this._filter(element) : this.groupsBK.slice()));
  }

  elementName(element: any) {
    return element[this.item!['viewValueSelect']!];
  }

  displayFn(element: any) {
    return element && element[this.item!['viewValueSelect']!] ? element[this.item!['viewValueSelect']!] : '';
  }

  private _filter(name: any) {

    if (typeof name === 'string') {
      const filterValue = name.toLowerCase();
      this.groups = this.groupsBK.filter((option: any) =>
        option[this.item!['viewValueSelect']!].toLowerCase().includes(filterValue));
    }

  }



  remove(element: string): void {
    const index = this.elements.indexOf(element);

    if (index >= 0) {
      this.elements.splice(index, 1);
    }

    this.elements.length == 0 ? this.form.controls[this.formName].setValue(undefined) : this.form.controls[this.formName].setValue(this.elements)
  }


  selected(event: any): void {
    this.elements.push(event.option.value);
    this.inputChips.nativeElement.value = '';
    this.elementCtrl.setValue(null);
    this.form.controls[this.formName].setValue(this.elements);
  }

  add(e: any) {

  }
}
